export const messages = {
  nominal: {
    id: 'admin/promotions.form.regular.view.benefit.nominal',
  },
  percentual: {
    id: 'admin/promotions.form.regular.view.benefit.percentual',
  },
  formula: {
    id: 'admin/promotions.form.regular.view.benefit.formula',
  },
  freeShipping: {
    id: 'admin/promotions.form.regular.view.benefit.free-shipping',
  },
  maxShipping: {
    id: 'admin/promotions.form.regular.view.benefit.max-shipping',
  },
  discount: {
    discount: {
      id: 'admin/promotions.form.regular.view.benefit.discount',
    },
    nominal: {
      id: 'admin/promotions.form.regular.view.benefit.discount.nominal',
    },
    percentual: {
      id: 'admin/promotions.form.regular.view.benefit.discount.percentual',
    },
    formula: {
      id: 'admin/promotions.form.regular.view.benefit.discount.formula',
    },
    shipping: {
      id: 'admin/promotions.form.regular.view.benefit.shipping',
    },
    nominalShipping: {
      id: 'admin/promotions.form.regular.view.benefit.shipping.nominal',
    },
    percentualShipping: {
      id: 'admin/promotions.form.regular.view.benefit.shipping.percentual',
    },
    freeShipping: {
      id: 'admin/promotions.form.regular.view.benefit.shipping.free',
    },
    maxShipping: {
      id: 'admin/promotions.form.regular.view.benefit.shipping.max',
    },
    maxPrice: { id: 'admin/promotions.form.regular.view.benefit.max-price' },
    gift: { id: 'admin/promotions.form.regular.view.benefit.gift' },
    loyalty: {
      id: 'admin/promotions.form.regular.view.benefit.loyalty',
    },
    nominalLoyalty: {
      id: 'admin/promotions.form.regular.view.benefit.loyalty.nominal',
    },
    percentualLoyalty: {
      id: 'admin/promotions.form.regular.view.benefit.loyalty.percentual',
    },
    priceTable: {
      id: 'admin/promotions.form.regular.view.benefit.price-table',
    },
  },
}
